module.exports = __webpack_public_path__ + "img/multiply_purple.818d57cf.png";